import devConfig from './config.dev';
import prodConfig from './config.prod';
export default {
  "dev":devConfig,
  "prod":prodConfig
}[process.env.UMI_ENV]